import { render, staticRenderFns } from "./DatasetInformation.vue?vue&type=template&id=c4c05f22"
import script from "./DatasetInformation.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetInformation.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports